import React, { useState, useEffect } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import enUS from 'date-fns/locale/en-US';
import 'react-big-calendar/lib/css/react-big-calendar.css';

import { useThemeContext } from '../../../fetchdata/ThemeContext';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import axiosInstance from "../../../axiosInstance";
import getDecryptData from '../../../helpers/getDecryptData';
import { Link } from 'react-router-dom';


const FullCalender = () => {

  
// 📍 Localization setup
const locales = {
  'en-US': enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 0 }),
  getDay,
  locales,
});

// 📍 Sample appointment events
const events = [
  {
    title: 'Dr. Sharma',
    patientName: 'Riya Kapoor',
    doctorName: 'Dr. Sharma',
    reason: 'Dental Checkup',
    location: 'City Care Clinic, Gurgaon',
    status: 'Confirmed',
    start: new Date(2025, 10, 3, 10, 0),
    end: new Date(2025, 10, 3, 10, 0),
   },             
  {
    title: 'Dr. Mehtaaaa',
    patientName: 'Arjun Yadav',
    doctorName: 'Dr. Mehta',
    reason: 'Eye Test',
    location: 'Vision Plus Center, Delhi',
    status: 'Pending',
    start: new Date(2025, 10, 3, 11, 0),
    end: new Date(2025, 10, 3, 11, 0),
  }, 
   {
    title: 'Dr. Mehta',
    patientName: 'Arjun Yadav',
    doctorName: 'Dr. Mehta',
    reason: 'Eye Test',
    location: 'Vision Plus Center, Delhi',
    status: 'Pending',
    start: new Date(2025, 10, 3, 11, 0),
    end: new Date(2025, 10, 3, 11, 0),
  }, 
   {
    title: 'Dr. Mehta',
    patientName: 'Arjun Yadav',
    doctorName: 'Dr. Mehta',
    reason: 'Eye Test',
    location: 'Vision Plus Center, Delhi',
    status: 'Pending',
    start: new Date(2025, 10, 3, 11, 0),
    end: new Date(2025, 10, 3, 11, 0),
  },  {
    title: 'Dr. Mehta',
    patientName: 'Arjun Yadav',
    doctorName: 'Dr. Mehta',
    reason: 'Eye Test',
    location: 'Vision Plus Center, Delhi',
    status: 'Pending',
    start: new Date(2025, 10, 3, 11, 0),
    end: new Date(2025, 10, 3, 11, 0),
  },  {
    title: 'Dr. Mehta',
    patientName: 'Arjun Yadav',
    doctorName: 'Dr. Mehta',
    reason: 'Eye Test',
    location: 'Vision Plus Center, Delhi',
    status: 'Pending',
    start: new Date(2025, 10, 3, 11, 0),
    end: new Date(2025, 10, 3, 11, 0),
  }, 
];

 // const CustomEvent = ({ event }) => (
//   <div className='multibook'>
//     <strong>{event.doctorName}</strong>
 
//   </div>
// );

const CustomEvent = ({ event }) => (
  <div className='multibook'>
    <strong>{event.title} </strong>
    {event.group && event.group.length > 1 && (
      <div style={{ fontSize: '10px', color: 'white' }}>Click to see all</div>
    )}
  </div>
);



// const groupEvents = (events, view) => {
//   if (view === 'month') return events;

//   const grouped = {};
//   const result = [];

//   events.forEach((e) => {
//     const key = `${e.start.getTime()}_${e.end.getTime()}`;
//     if (!grouped[key]) {
//       grouped[key] = [e];
//     } else {
//       grouped[key].push(e);
//     }
//   });

//   for (const key in grouped) {
//     const group = grouped[key];
//     const first = group[0];

//     result.push({
//       ...first,
//       title: group.length > 1 ? ` ${first.title} + ${group.length - 1} more` : first.title,
//       group: group, // keep all grouped events here
//     });
//   }

//   return result;
// };

// const groupEvents = (orders, view) => {
//   const grouped = {};
//   const result = [];

//   orders.forEach((order) => {
//     // Parse PickupDate (ensure it's a valid date)
//     const pickupDate = new Date(order.PickupDate); // Parse the PickupDate

//     if (isNaN(pickupDate)) {
//       console.error(`Invalid PickupDate: ${order.PickupDate}`);
//       return; // Skip if PickupDate is invalid
//     }

//     // Check if Ltime exists and is in the correct format (HH:mm)
//     if (order.Ltime) {
//       const [hours, minutes] = order.Ltime.split(':');
      
//       // Ensure that hours and minutes are valid numbers
//       if (!isNaN(hours) && !isNaN(minutes)) {
//         // Set hours and minutes on the PickupDate
//         pickupDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
//       } else {
//         console.error(`Invalid Ltime format: ${order.Ltime}`);
//         pickupDate.setHours(0, 0, 0, 0); // Default to midnight if Ltime is invalid
//       }
//     } else {
//       // If no Ltime, default to midnight
//       pickupDate.setHours(0, 0, 0, 0);
//     }

//     // Group by the timestamp of the combined date and time (pickupDate)
//     const key = `${pickupDate.getFullYear()}-${pickupDate.getMonth()}-${pickupDate.getDate()}-${pickupDate.getHours()}-${pickupDate.getMinutes()}`;

//     // Group orders by their start time (key)
//     if (!grouped[key]) {
//       grouped[key] = [order];
//     } else {
//       grouped[key].push(order);
//     }
//   });

//   // Prepare the result with grouped events
//   for (const key in grouped) {
//     const group = grouped[key];
//     const first = group[0];  // Get the first event in the group

//     // Define the start and end dates
//     const pickupDate = new Date(first.PickupDate);
//     const [hours, minutes] = first.Ltime.split(':');

//     // Set the start date with correct year, month, day, hour, and minute
//     const start = new Date(pickupDate.getFullYear(), pickupDate.getMonth(), pickupDate.getDate(), parseInt(hours), parseInt(minutes));
//     const end = new Date(pickupDate.getFullYear(), pickupDate.getMonth(), pickupDate.getDate(), parseInt(hours), parseInt(minutes));

//     result.push({
//       title: first.userId.username,  // You can modify this based on the order data
//       patientName:  first?.UserDetails[0]?.name,  // You can modify this based on the order data
//       doctorName: first?.employeeId?.username,  // Add doctor name here
//       reason: first?.addProduct[0]?.title,  // Add reason (you can modify this based on the order data)
//       location: first?.UserDetails[0]?.address,  // Modify location based on the order data
//       status: first.status === 1 ? 'Confirmed' : 'Pending',  // Status check, assuming 1 is confirmed
//       start: start,  // Start date in the correct format
//       end: end,      // End date in the correct format
//     });
//   }

//   console.log('{groupEvents(AllOrder, view)}', result , events);

//   return result;
// };
 

const groupEvents = (orders) => {
  const groups = {};

  orders.forEach(order => {
    if (!order.PickupDate) return;

    const dateKey = new Date(order.PickupDate).toDateString();

    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }

    groups[dateKey].push(order);
  });

  const result = [];

  Object.keys(groups).forEach((group) => {
    const groupOrders = groups[group];

    if (groupOrders.length === 0) return;

    const first = groupOrders[0];
    const pickupDate = new Date(first.PickupDate);

    // ====== FIXED START TIME ======
    const [sh, sm] = first.Ltime.split(":");
    const start = new Date(
      pickupDate.getFullYear(),
      pickupDate.getMonth(),
      pickupDate.getDate(),
      parseInt(sh),
      parseInt(sm)
    );

    // ====== FIXED END TIME (Etime) ======
    let end;
    if (first.Etime) {
      const [eh, em] = first.Etime.split(":");
      end = new Date(
        pickupDate.getFullYear(),
        pickupDate.getMonth(),
        pickupDate.getDate(),
        parseInt(eh),
        parseInt(em)
      );
    } else {
      // fallback to same as start
      end = new Date(start);
    }

    result.push({
      title: first.userId?.username || "Appointment",
      patientName: first?.UserDetails?.[0]?.name || "",
      doctorName: first?.employeeId?.username || "",
      reason: first?.addProduct?.[0]?.title || "Consultation",
      location: first?.UserDetails?.[0]?.address || "",
      status: first.status === 1 ? "Confirmed" : "Pending",

      // ==== FINAL PROPER EVENT DURATION ====
      start: start,
      end: end,

      group: group,
    });
  });

  return result;
};



    const [AllEvent, setAllEvent] = useState([]);

const handleSelectEvent = (event) => {
  setAllEvent(event);
  console.log('eventevent',event)
  // if (event.group && event.group.length > 0) {
  //   const details = event.group.map(e => `
  //     • ${e.title} (${e.patientName}) at ${e.start.toLocaleTimeString()}
  //   `).join('\n');

  //   alert(`Appointments:\n${details}`);
  // } else {
  //   alert(`Doctor: ${event.doctorName}\nPatient: ${event.patientName}`);
  // }
};

const handleCancelEvent = () => {
  setAllEvent([]);
};

 // const handleSelectEvent = (event) => {
//   if (event.allDay) return;

//   alert(
//     `Appointment Details:
// Doctor: ${event.doctorName}
// Patient: ${event.patientName}
// Reason: ${event.reason}
// Time: ${event.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${event.end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
// Location: ${event.location}
// Status: ${event.status}`
//   );
// };

  const [loading, setLoading] = useState(true);

    const [AllOrder, setAllOrder] = useState([]);

  const getUserAllOrder = async () => {
        const decryptdatajson = await getDecryptData();
    
        const id = decryptdatajson?._id;
    try {
        const response = await axiosInstance.get(`/admin/all-order?search=&startDate=&endDate=&status=&productId=&type=3&userId=${id}`);
        

        const {Order} = response?.data;
        if(Order){
           setAllOrder(Order) 
        }else{
          setAllOrder([])
        }
         console.log('setAllOrder', response.data)

    } catch (error) {
        console.error('Error fetching user products:', error);
        setAllOrder([])
    }finally{
      setLoading(false);
    }
};
 

  useEffect(() => {
    getUserAllOrder();
  }, []);

  const [view, setView] = useState('week');


  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
 
{(AllEvent && AllEvent.length !== 0) && (
  <>
    <div className='toast-wrap'>
      <div
        className="toast fade show my-toast-Book bg-light"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        data-bs-delay={3000}
        data-bs-autohide="false"
      >
        <div className="toast-header">
          <i className="ri-suitcase-line text-primary fs-5"></i>
          <strong className="me-auto ms-2">New Appointment</strong> {/* Changed to Appointment */}
           
          <button
            className="btn btn-close position-relative p-1 shadow-none"
            type="button"
            onClick={handleCancelEvent}
          >
            <i className="close"></i>
          </button>
        </div>
        <div className="toast-body">
          <div className='m-0 overflow-y-scroll pe-1' style={{ maxHeight: '60vh' }}>
            {AllEvent.group && AllEvent.group.length > 0 ? AllEvent.group.map((booking, index) => (
              <div className="card p-3 mb-2" key={index}>
                <div className="d-flex m-0">
                  <div className="media-body m-0">
                    <h6 className="mt-2 mb-0">{booking.patientName}</h6> {/* Patient name */}
                    <p className='small m-0 fw-light text-dark'>{booking.location}</p> {/* Location */}
                  </div>
                </div>
                <p className='fw-bold small m-0'>
                  {booking.start ? new Date(booking.start).toLocaleDateString('en-US', {
                    weekday: 'short',
                    day: '2-digit',
                    month: 'short'
                  }) : 'NA'} at {booking.start ? new Date(booking.start).toLocaleTimeString('en-US') : 'NA'} {/* Date and Time */}
                </p>
                <p className='small m-0'>
                  <strong>Reason:</strong> {booking.reason} {/* Reason */}
                </p>
                <hr />
                <div className="d-flex justify-content-between align-items-center gap-2">
                 
                  <Link to="/all-order-doctor" className="btn btn-sm mb-2 me-2 btn-primary">
                    view <i className="ri-arrow-right-line ms-2" /> {/* Changed text */}
                  </Link>
                </div>
              </div>
            )) : AllEvent && 
             <div className="card p-3 mb-2" >
                <div className="d-flex m-0">
                  <div className="media-body m-0">
                    <h6 className="mt-2 mb-0">{AllEvent.patientName}</h6> {/* Patient name */}
                    <p className='small m-0 fw-light text-dark'>{AllEvent.location}</p> {/* Location */}
                  </div>
                </div>
                <p className='fw-bold small m-0'>
                  {AllEvent.start ? new Date(AllEvent.start).toLocaleDateString('en-US', {
                    weekday: 'short',
                    day: '2-digit',
                    month: 'short'
                  }) : 'NA'} at {AllEvent.start ? new Date(AllEvent.start).toLocaleTimeString('en-US') : 'NA'} {/* Date and Time */}
                </p>
                <p className='small m-0'>
                  <strong>Reason:</strong> {AllEvent.reason} {/* Reason */}
                </p>
                <hr />
                <div className="d-flex justify-content-between align-items-center gap-2">
                  

                   <Link to="/all-order-doctor" className="btn btn-sm mb-2 me-2 btn-primary">
                    view <i className="ri-arrow-right-line ms-2" /> {/* Changed text */}
                  </Link>
                </div>
              </div>
            }

          </div>
          
        </div>
      </div>
    </div>
  </>
)}



        <div className={`container mt-4 position-relative p-0 ${view+'-container'} `} id="videocall-box">
          <div style={{ height: '80vh' }}  >
            {loading ? 
                      <div style={{ height: '80vh' }} className='d-flex align-items-center justify-content-center'>

            <span
                            className="spinner-border spinner-border-sm" style={{width:200,height:200}}
                            role="status"
                            aria-hidden="true"
                          ></span>
                          </div>
                           :

<Calendar
  localizer={localizer}
  events={groupEvents(AllOrder, view)}
  startAccessor="start"
  endAccessor="end"
  defaultView="week"
  views={['month', 'week', 'day']}
  showMultiDayTimes={true}
  popup={true}
  popupOffset={{ x: 30, y: 20 }} // helps spacing in week/day views
  components={{
    event: CustomEvent
  }}
  onSelectEvent={handleSelectEvent}
  style={{ height: '100%' }}
  onView={(newView) => {
          console.log('View changed to:', newView);
          setView(newView);
        }}
      
/>
 
  }
           
          </div>
        </div>
      </main>
    </>
  );
};

export default FullCalender;
